/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";

export const generalCivilLawRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
};
